// extracted by mini-css-extract-plugin
module.exports = {"grid":"contact-text-module--grid--3uYDC","socials":"contact-text-module--socials--AMFZ2","biography":"contact-text-module--biography--3siz7"};